import Paragraph from 'structure/launchpad/components/Typography';
import React from 'react';
import { DetailsRow } from 'structure/staking/components/DetailRow';
import { StakingPool, Calculation, UserPoolInfo } from 'api/StakingAPI';
import { mapCalculation } from 'structure/staking/utils/mapCalculation';
import { useTranslation } from 'react-i18next';
import { Icons } from '@dapp/multi-lib/ui/icons';
import { twMerge } from 'tailwind-merge';
import { HorizontalLine } from '@dapp/multi-lib/sdaoui/HorizontalLine';

type StakeDetailsProps = {
  action: 'stake' | 'withdraw';
  userPoolInfo: UserPoolInfo;
  pool: StakingPool;
  calculation: Calculation;
  loading?: boolean;
};

export function StakeDetails({
  pool,
  userPoolInfo,
  action,
  calculation,
  loading = false,
}: StakeDetailsProps) {
  const { t } = useTranslation('common');
  const data = mapCalculation(pool, calculation);

  const up = action === 'stake';

  const apr = pool.depositTokenSymbol === 'SDAO' ? '0%' : `${data.apr}%`;

  return (
    <div className='flex flex-col'>
      <Paragraph className='pb-1 text-sm text-[#F7F8F8]'>
        {t('STAKING.DETAILS')}
      </Paragraph>
      <HorizontalLine className='my-2' />
      <div
        className={twMerge(
          loading ? 'animate-pulse' : '',
          'flex flex-col gap-3'
        )}
      >
        <DetailsRow
          label={`${pool.depositTokenSymbol} ${t('STAKING.STAKED')}`}
          value={`${t('tokenAmount', { value: data.staked })} ${data.tokenSymbol}`}
        />
        <DetailsRow
          label={t('STAKING.SREP')}
          value={
            <div className='gap1 flex flex-row items-center'>
              <Paragraph className='text-sm text-[#F7F8F8]'>
                {t('srep', { value: data.tentativeREP })}
              </Paragraph>
              <Icons
                icon={up ? 'triangle_up' : 'triangle_down'}
                iconHeight='13'
                iconWidth='13'
                viewboxHeight='13'
                viewboxWidth='10'
                fillColor={up ? '#54FAAA' : '#FB5656'}
              />
            </div>
          }
        />
        <DetailsRow label={t('STAKING.APR')} value={apr} />
        <DetailsRow
          label={t('STAKING.UNLOCK_DATE')}
          value={`${data.unlockDate}`}
        />
      </div>
      <HorizontalLine className='my-2' />
    </div>
  );
}
